// removed by extract-text-webpack-plugin
module.exports = {"block":"text__block-WswKx","textfield":"text__textfield-ZlgwD","isDisabled":"text__isDisabled-104-7","limit":"text__limit-37ccF","tooltip":"text__tooltip-3kAXg","showLimit":"text__showLimit-1iFZ- text__textfield-ZlgwD","popupMode":"text__popupMode-2ysyr","hasError":"text__hasError-noYp_","tooltipWrapper":"text__tooltipWrapper-1GkVE","leftToRightWrapper":"text__leftToRightWrapper-2h2CI","topToBottomWrapper":"text__topToBottomWrapper-EneVf","topToBottom":"text__topToBottom-EtcPX","leftToRight":"text__leftToRight-1i4Nu"};


//////////////////
// WEBPACK FOOTER
// ./~/account-ui/text/text.css
// module id = 864
// module chunks = 0